<!--
*****************************************************************************
*File : undue-delay.vue
*Module : Dashboard Frontend
*Purpose : Display the report for the undue-delay .
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-container
    id="undue-delay"
    fluid
    tag="section"
  >
  <v-form class="px-3">
  <v-card>
    <base-material-card
          color="success"
          icon="mdi-magnify"
          inline
          class="px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              Select Alert Type and Wagon Type <span class="body-1"></span>
            </div>
          </template>

      <v-layout>
        <v-container fluid>
          <v-row align="center">
      <v-col
        class="d-flex"
        cols="12"
        sm="6"
      >

      <v-select
          :items="itemsAlert"
          label="Choose Alert Type"
        ></v-select>
      </v-col>
      </v-row>
      </v-container>

        <v-container fluid>
          <v-row align="center">
      <v-col

        class="d-flex"
        cols="12"
        sm="6"
        title
      >
      <v-select
          :items="itemsWagon"
          label="Choose Wagon Type"
        ></v-select>
      </v-col>
      </v-row>
      </v-container>
      </v-layout>

<v-spacer></v-spacer>
    <v-flex md4 class="py-4 px-16">
      <v-card-title>
        <div v-if="epochStart <= epochEnd">
      <v-btn color="success" v-on:click="isHiddenSelect = true" @click="submit">Generate Report</v-btn>
        </div>
      </v-card-title>
    </v-flex>
  <div v-if="((epochStart > epochEnd))">
    <h3 class="ml-16 red--text font-weight-bold">Kindly choose Start Datetime lesser than the End Datetime.</h3>
  </div>
    </base-material-card>
  </v-card>

  <base-material-card
  v-if="isHiddenSelect"
  color="indigo"
  icon="mdi-train"
  inline
  class="px-5 py-3"
  >
  <template v-slot:after-heading>
    <div class="display-1 font-weight-light">
      Defectwise Report - Month wise
      </div>
      </template>
       <v-row>
      <v-col
        cols="24"
        sm="12"
        lg="12">

      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px;"
          />
 </v-col>
 </v-row>

  <v-divider class="mt-3" />


  <v-data-table
  :disabled = isFormValidMonthly
  :headers="headers_monthly"
  :items="entry_train_monthly"
  :search.sync="search"
  :generate-report.sync="generateReport"
  :sort-by="['entry_ts']"
  :sort-desc="[false]"
  multi-sort
  >

  <template v-slot:[`item.month`]="{item}">
    <v-btn
    @click="isHiddenDaily = true;
    isHiddenSelect=false;
    readMonth(item.month)"
    >{{item.month}}</v-btn>
  </template>

  </v-data-table>
  <v-btn color="primary" @click="handleMonthDownload">Export as csv/xlsx</v-btn>
</base-material-card>

  <base-material-card
  v-if="isHiddenDaily"
  color="indigo"
  icon="mdi-train"
  inline
  class="px-5 py-3"
  absolute
  >
  <template absolute v-slot:after-heading>

    <div class="display-1 font-weight-light" absolute>
      Defectwise Report - Day wise on {{monthValue}}
    </div>
    </template>

     <v-row>
      <v-col
        cols="24"
        sm="12"
        lg="12">
       <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px;"
          />

    </v-col>
    </v-row>

  <v-data-table
  :disabled = isFormValidDaily
  :headers="headers_daily"
  :items="entry_train_daily"
  :generate-report.sync="generateReport"
  :search.sync="search"
  :sort-by="['entry_ts']"
  :sort-desc="[false]"
  multi-sort
  >
    <template v-slot:[`item.date`]="{item}">
    <v-btn
    v-on:click="isHiddenDaily = false;
    isHiddenTrainWise= true;
    readDate(item.date) "
    >
    {{item.date}}</v-btn>
  </template>

  </v-data-table>

<v-container grid-list-xs>
  <v-row >
    <v-col class="text-left">
    <v-btn color="primary" @click="handleDayDownload">Export as csv/xlsx</v-btn>
    </v-col>
    <v-col class="text-right">
  <v-btn class="text-end" color="primary" justify="end" right v-on:click="isHiddenDaily = false " @click="isHiddenSelect = true"> Display Month Wise Report </v-btn>
</v-col>
</v-row>

</v-container>
</base-material-card>

<base-material-card
  v-if="isHiddenTrainWise"
  color="indigo"
  icon="mdi-train"
  inline
  class="px-5 py-3"
  >
  <template v-slot:after-heading >
    <div class="display-1 font-weight-light" absolute>
      Defectwise Report - Train wise on {{dateValue}}
    </div>
    </template>

  <v-row>
      <v-col
        cols="24"
        sm="12"
        lg="12">
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px; "
          />
    </v-col>
    </v-row>


  <v-data-table
  :disabled = isFormValidTrainWise
  :headers="headers_train_wise"
  :items="entry_train_wise"
  :generate-report.sync="generateReport"
  :search.sync="search"
  :sort-by="['entry_ts']"
  :sort-desc="[false]"
  multi-sort
  >
  <template v-slot:[`item.train_id`]="{item}">
    <router-link to="/report/train-detail-report">{{item.train_id}}</router-link>
  </template>

  </v-data-table>

  <v-container grid-list-xs>
  <v-row >
    <v-col class="text-left">
  <v-btn color="primary" @click="handleTrainWiseDownload">Export as csv/xlsx</v-btn>
     </v-col>
     <v-col class="text-right">
     <v-btn color="primary" @click="isHiddenDaily = true; isHiddenTrainWise = false" > Display Day Wise Report  </v-btn>
</v-col>
</v-row>
</v-container>
</base-material-card>


  </v-form>
  </v-container>

</template>
<script>
import axios from 'axios';
import Api from '@/views/service/api'
import ApiResponse from '../service/api-response'

export default {
  name: "UndueDelay",

  data() {
    return {

      itemsAlert: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      itemsWagon: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      monthValue: '',
      dateValue: '',
      search: '',
      entry_train_monthly_arr: [],
      entry_train_daily_arr: [],
      total_train_wise_arr: [],
      startdate: new Date().toISOString().substr(0, 10),
      startdateFormatted: this.formatDate1(new Date().toISOString().substr(0, 10)),
      enddate: new Date().toISOString().substr(0, 10),
      enddateFormatted: this.formatDate1(new Date().toISOString().substr(0, 10)),
      epochStart: this.epochConvert(new Date().toISOString().substr(0, 10)),
      epochEnd: this.epochConvert(new Date().toISOString().substr(0, 10)),
      startDate: '',
      endDate: '',
      generateReport: '',
      trainsEE: [],
      torpedo_long_wait: [],
      entry_train: [],
      unloadEntryTS_Arr: [],
      unloadExitTS_Arr: [],
      undue_timeDiffInHMS: [],
      exelArr: [],
      i: '',
      isFormValidMonthly: true,
      isFormValidDaily: true,
      isFormValidTrainWise: true,
      modal: false,
      modal1: false,
      isHiddenSelect: false,
      isHiddenReport: false,
      isHiddenDaily: false,
      isHiddenTrainWise: false,
      downloadLoading: false,
      filename: '',
      autoWidth: true,
      bookType: 'xlsx',
      headers_monthly: [
        { text: 'Sl. No', value: 'sl_no', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Year', value: 'year', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Month', value: 'month', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Trains', value: 'total_trains', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Trains with Critical', value: 'train_critical', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Wheels', value: 'wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Critical Wheels', value: 'critical_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'MDIL >= 3', value: 'mdil', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'ILF >= 4.5', value: 'ilf', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'WILD alerts', value: 'wild_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'MVIS alerts', value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      headers_daily: [
        { text: 'Sl. No', value: 'sl_no', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Date', value: 'date', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Trains', value: 'total_trains', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Train with alerts', value: 'train_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Wheels', value: 'total_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'MDIL >= 3 ', value: 'mdil', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'ILF >= 4.5', value: 'ilf', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'WILD Alerts', value: 'wild_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'MVIS Alerts', value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      headers_train_wise: [
        { text: 'Sl. No', value: 'sl_no', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Tagged Train ID', value: 'train_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'DFIS ID', value: 'dfis', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Direction', value: 'direction', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Entry Time', value: 'entry_time', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Train Speed ', value: 'train_speed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Axles', value: 'total_axels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'WILD Alerts', value: 'wild_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'MVIS Alerts', value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      entry_train_monthly: [
        {
          sl_no: 1,
          year: 2022,
          month: 'Jan',
          total_trains: 10,
          train_critical: 'No',
          wheels: 10,
          critical_wheels: 0,
          mdil: 2.0,
          ilf: 2.0,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 2,
          year: 2022,
          month: 'Feb',
          total_trains: 10,
          train_critical: 'No',
          wheels: 10,
          critical_wheels: 0,
          mdil: 2.0,
          ilf: 3.0,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 3,
          year: 2022,
          month: 'Mar',
          total_trains: 10,
          train_critical: 'No',
          wheels: 10,
          critical_wheels: 0,
          mdil: 2.0,
          ilf: 2.0,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 4,
          year: 2022,
          month: 'Apr',
          total_trains: 10,
          train_critical: 'No',
          wheels: 10,
          critical_wheels: 0,
          mdil: 2.0,
          ilf: 2.0,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 5,
          year: 2022,
          month: 'May',
          total_trains: 10,
          train_critical: 'No',
          wheels: 10,
          critical_wheels: 0,
          mdil: 2.0,
          ilf: 2.0,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 6,
          year: 2022,
          month: 'Jun',
          total_trains: 10,
          train_critical: 'No',
          wheels: 10,
          critical_wheels: 0,
          mdil: 2.0,
          ilf: 2.0,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
      ],

      entry_train_daily: [
        {
          sl_no: 1,
          date: '09/06/2022',
          total_trains: 40,
          train_alerts: 0,
          total_wheels: 7998,
          mdil: 2.0,
          ilf: 10,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 2,
          date: '10/06/2022',
          total_trains: 40,
          train_alerts: 0,
          total_wheels: 7998,
          mdil: 2.0,
          ilf: 10,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 3,
          date: '11/06/2022',
          total_trains: 40,
          train_alerts: 0,
          total_wheels: 7998,
          mdil: 2.0,
          ilf: 10,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 4,
          date: '12/06/2022',
          total_trains: 40,
          train_alerts: 0,
          total_wheels: 7998,
          mdil: 2.0,
          ilf: 10,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
        {
          sl_no: 5,
          date: '13/06/2022',
          total_trains: 43,
          train_alerts: 0,
          total_wheels: 7998,
          mdil: 7,
          ilf: 1,
          wild_alerts: 'None',
          mvis_alerts: 'None'
        },
    ],
    entry_train_wise: [
      {
        sl_no: 1,
        train_id: 'T20220609031648',
        dfis: 123,
        direction: 'down',
        entry_time: '1/6/2022  1:26:21 AM',
        train_speed: '58.37',
        total_axels: 9,
        wild_alerts: 0,
        mvis_alerts: 0,
      },
      {
        sl_no: 1,
        train_id: 'T20220609031648',
        dfis: 123,
        direction: 'down',
        entry_time: '1/6/2022  2:26:21 AM',
        train_speed: '58.37',
        total_axles: 9,
        wild_alerts: 0,
        mvis_alerts: 0,
      },
      {
        sl_no: 1,
        train_id: 'T20220609031648',
        dfis: 123,
        direction: 'down',
        entry_time: '1/6/2022  3:26:21 AM',
        train_speed: '58.37',
        total_axles: 9,
        wild_alerts: 0,
        mvis_alerts: 0,
      },
      {
        sl_no: 1,
        train_id: 'T20220609031648',
        dfis: 123,
        direction: 'down',
        entry_time: '1/6/2022  4:26:21 AM',
        train_speed: '58.37',
        total_axles: 9,
        wild_alerts: 0,
        mvis_alerts: 0,
      },
      {
        sl_no: 1,
        train_id: 'T20220609031648',
        dfis: 123,
        direction: 'down',
        entry_time: '1/6/2022  5:26:21 AM',
        train_speed: '58.37',
        total_axles: 9,
        wild_alerts: 0,
        mvis_alerts: 0,
      },
    ],
    }
  },

  watch: {
    startdate (val) {
      this.startdateFormatted = this.formatDate1(this.startdate)
      this.epochStart = this.epochConvert(this.startdate)
    },
    enddate (val) {
      this.enddateFormatted = this.formatDate1(this.enddate)
      this.epochEnd = this.epochConvert(this.enddate)
    },
  },

  methods: {

    readMonth(month) {
      this.monthValue = month;
    },
    readDate(date) {
      this.dateValue = date;
    },

    formatDate1 (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return (`${day}-${month}-${year}`)
    },
    epochConvert (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return ((new Date(year, month - 1, day)).getTime())
    },
    parseDate1 (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return (`${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`)
    },
    handleDownload() {
      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Train Entry Time', 'Train Exit Time', 'Unloaded Torpedo Entry Time', 'Unloaded Torpedo Exit Time','Undue Delay']
        const filterVal = ['TrainEntryTime', 'TrainExitTime', 'UnloadedTorpedoEntry', 'UnloadedTorpedoExit','UndueDelay']
        const list = this.exelArr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:'undue-delay'+this.startDate+"-"+this.endDate,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })

    },


    convertTimestamp(timestamp) {
        var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
        sec = ('0' + d.getSeconds()).slice(-2),
        ampm = 'AM',
        time;

        if (hh > 12) {
          h = hh - 12;
          ampm = 'PM';
        } else if (hh === 12) {
          h = 12;
          ampm = 'PM';
        } else if (hh == 0) {
          h = 12;
        }

      // ie: 2013-02-18 8:35 AM
      time =  dd + '-' + mm + '-' + yyyy + ' ' + h + ':' + min + ':' + sec + ' ' + ampm

      return time;
      },

      getCurrentDateIST() {
        var dateUTC = (new Date());
        var dateUTC = dateUTC.getTime();
        var dateIST = new Date(dateUTC);
        //date shifting for IST timezone (+5 hours and 30 minutes)
        dateIST.setHours(dateIST.getHours() + 5);
        dateIST.setMinutes(dateIST.getMinutes() + 30);
        return (new Date(dateIST).toISOString().substr(0, 10));
      },

      convertTimestampOnlyDMY(timestamp) {
        var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ( (d.getMonth() + 1)),	// Months are zero based. Add leading 0.
        dd = ( d.getDate()),			// Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
        sec = ('0' + d.getSeconds()).slice(-2),
        ampm = 'AM',
        time;

      // ie: 2013-02-18 8:35 AM
      time =  mm+'/'+dd+'/'+yyyy; //+ ' ' + ampm

      return time;
      },



      formatDate(d)
      {
        var date = new Date(d)
        var dd = date.getDate();
        var mm = date.getMonth()+1;
        var yyyy = date.getFullYear();
        var hh = d.getHours();
        var min = ('0' + d.getMinutes()).slice(-2);		// Add leading 0.
        var sec = ('0' + d.getSeconds()).slice(-2);
        if(dd<10){dd='0'+dd}
        if(mm<10){mm='0'+mm};
        return d = yyyy+'-'+mm+'-'+dd+' '+hh+':'+min+':'+sec
      },

      formatOnlyDMY(d)
      {
        var date = new Date(d)
        var dd = date.getDate();
        var mm = date.getMonth()+1;
        var yyyy = date.getFullYear();
        return d = mm+'/'+dd+'/'+yyyy
      },

      rearrangeDate(d)
      {
        var yyyy = d.split("-")[2];
        var mm = d.split("-")[1];
        var dd = d.split("-")[0];

        return d = mm+'/'+dd+'/'+yyyy
      },

    getLongerTime_rep(curEntry, start_date, avgTime_Arr) {
      function parseDate(str) {
            var mdy = str.split('/');
            return new Date(mdy[2], mdy[0]-1, mdy[1]);
        }

        function datediff(first, second) {
            // Take the difference between the dates and divide by milliseconds per day.
            // Round to nearest whole number to deal with DST.
            return Math.round((second-first)/(1000*60*60*24));
        }

        // to check no. of days b/w start & end dates
        var avgTimeIndx = ((datediff(parseDate(this.rearrangeDate(start_date)), parseDate(this.convertTimestampOnlyDMY(curEntry)))));
        
        return avgTime_Arr[avgTimeIndx];

    },


      submit() {

      this.startDate = (this.startdateFormatted);
      this.endDate = (this.enddateFormatted);
      Api().post('/api/entryexit', {
        start: this.startDate,
        end: this.endDate

      })
    .then((response) => {
      this.trainsEE = response.data;
      this.entry_train = this.trainsEE.entry_train;
      this.unloadEntryTS_Arr = this.trainsEE.unloadEntryTS_Arr;
      this.unloadExitTS_Arr = this.trainsEE.unloadExitTS_Arr;
      this.undue_timeDiffInHMS = this.trainsEE.undue_timeDiffInHMS;

      for(let i in this.entry_train ){

        let trainEntryTime =this.convertTimestamp(this.entry_train[i].entry_ts)
        let trainExitTime =this.convertTimestamp(this.entry_train[i].exit_ts)
        let torpedoEntryCount =this.convertTimestamp(this.entry_train[i].unload_entry_ts)
        let torpedoExitCount=this.convertTimestamp(this.entry_train[i].unload_exit_ts)
        let UndueDelay =this.getLongerTime_rep(this.entry_train[i].entry_ts, this.startdateFormatted, this.undue_timeDiffInHMS)
        let data={
          'TrainEntryTime' :trainEntryTime,
          'TrainExitTime':trainExitTime,
          'UnloadedTorpedoEntry':torpedoEntryCount,
          'UnloadedTorpedoExit':torpedoExitCount,
          'UndueDelay' : UndueDelay
        }
        this.exelArr.push(data)
     }


    })
    .catch(function (error) {
      ApiResponse.checkErrorCode(error.response.status);
    });
    },

    handleMonthDownload() {

      // data fields

      for (let i in this.entry_train_monthly) {
      let slNo = (this.entry_train_monthly[i].sl_no);
      let Year = (this.entry_train_monthly[i].year);
      let Month = (this.entry_train_monthly[i].month);
      let totalTrains = (this.entry_train_monthly[i].total_trains);
      let trainCritical = (this.entry_train_monthly[i].train_critical);
      let Mdil = (this.entry_train_monthly[i].mdil);
      let Ilf = (this.entry_train_monthly[i].ilf);
      let wildAlerts = (this.entry_train_monthly[i].wild_alerts);
      let mvisAlerts = (this.entry_train_monthly[i].mvis_alerts);

      let data = {
      'SlNo' : this.slNo,
      'Year' : this.Year,
      'Month' :this.Month,
      'TotalTrains' : this.totalTrains,
      'TrainCritical' : this.trainCritical,
      'Mdil' : this.Mdil,
      'Ilf' : this.Ilf,
      'WildAlerts' : this.wildAlerts,
      'MvisAlerts' : this.mvisAlerts,
    }
    this.entry_train_monthly_arr.push(data);
    }

    this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Sl No', 'Year', 'Month', 'Total Trains', 'Train Critical', 'MDIL', 'ILF', 'WILD Alerts', 'MVIS Alerts']
        const filterVal = ['SlNo', 'Year','Month' ,'TotalTrains', 'TrainCritical' ,'Mdil', 'Ilf', 'WildAlerts' ,'MvisAlerts']
        const list = this.entry_train_monthly_arr;
        const data = JSON.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: 'tHeader',
          data,
          filename: 'train_monthly_report',
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.downloadLoading = false
    })

    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(filterVal);
    },


    handleDayDownload() {

      // data fields

      for (let i in this.entry_train_daily) {
      let slNo = (this.entry_train_daily[i].sl_no);
      let Date = (this.entry_train_daily[i].date);
      let totalTrains = (this.entry_train_daily[i].total_trains);
      let totalAlerts = (this.entry_train_daily[i].total_alerts);
      let totalWheels = (this.entry_train_daily[i].total_wheels);
      let Mdil = (this.entry_train_daily[i].mdil);
      let Ilf = (this.entry_train_daily[i].ilf);
      let wildAlerts = (this.entry_train_daily[i].wild_alerts);
      let mvisAlerts = (this.entry_train_daily[i].mvis_alerts);
    }

    let data = {
      'SlNo' : this.slNo,
      'Date' : this.Year,
      'TotalTrains' : this.totalTrains,
      'TrainCritical' : this.trainCritical,
      'TotalWheels': this.totalWheels,
      'Mdil' : this.Mdil,
      'Ilf' : this.Ilf,
      'WildAlerts' : this.wildAlerts,
      'MvisAlerts' : this.mvisAlerts,
    }
    this.entry_train_daily_arr.push(data);

    this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Sl No', 'Date', 'Total Trains', 'Train Alerts', 'Total Wheels', 'MDIL', 'ILF', 'WILD Alerts', 'MVIS Alerts']

        const data = JSON.stringify(this.entry_train_monthly_arr);

        excel.export_json_to_excel({
          header: 'tHeader',
          data,
          filename: 'train_daily_report',
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.downloadLoading = false
    })
    },



    handleTrainWiseDownload() {

      // data fields

      for (let i in this.entry_train_wise) {
      let slNo = (this.entry_train_wise[i].sl_no);
      let trainId = (this.entry_train_wise[i].train_id);
      let Dfis = (this.entry_train_wise[i].dfis);
      let Direction = (this.entry_train_wise[i].direction);
      let entryTime = (this.entry_train_wise[i].entry_time);
      let trainSpeed = (this.entry_train_wise[i].train_speed);
      let totalAxles = (this.entry_train_wise[i].total_axles);
      let wildAlerts = (this.entry_train_wise[i].wild_alerts);
      let mvisAlerts = (this.entry_train_wise[i].mvis_alerts);
    }

    let data = {
      'SlNo' : this.slNo,
      'TrainID' : this.trainId,
      'Dfis' : this.Dfis,
      'Direction' : this.Direction,
      'EntryTime' : this.entryTime,
      'TrainSpeed' : this.trainSpeed,
      'TotalAxles' : this.totalAxles,
      'WildAlerts' : this.wildAlerts,
      'MvisAlerts' : this.mvisAlerts,
    }
    this.total_train_wise_arr.push(data);

    //func

    this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Sl No', 'Year', 'Month', 'Total Trains', 'Train Critical', 'MDIL', 'ILF', 'WILD Alerts', 'MVIS Alerts']

        const data = JSON.stringify(this.entry_train_monthly_arr);

        excel.export_json_to_excel({
          header: 'tHeader',
          data,
          filename:'train_wise_report',
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.downloadLoading = false
    })
    },
    },

  }


</script>

<style lang="scss">
.v-sheet {
  border-radius: 4px;
}
</style>
